import { onrampDocumentation } from '../../documentation';

export const Onramp = () => {
  return (
    <>
      {onrampDocumentation.map((doc) => (
        <div id={doc.id} key={doc.id}>
          {doc.content}
        </div>
      ))}
    </>
  );
};
